import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { AppFlags } from '../api/contracts/flags';
import { HttpMethods } from '../api/api.enums';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FlagsService {
  private readonly _flags$: BehaviorSubject<AppFlags | null> =
    new BehaviorSubject<AppFlags | null>(null);

  public readonly flags$: Observable<AppFlags | null> =
    this._flags$.asObservable();

  constructor(private readonly apiService: ApiService) {
    this.retrieveFlags().subscribe();
  }

  retrieveFlags(): Observable<AppFlags> {
    return this.apiService
      .request<AppFlags>({
        method: HttpMethods.GET,
        url: `${environment.apiUrl}/flags`,
      })
      .pipe(
        map((res) => res.body as AppFlags),
        tap((flags) => this._flags$.next(flags))
      );
  }
}
